import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Footer from '@/app/shared/components/footer/Footer.vue';
import store from '../../store';
import {TripSegments} from 'app/shared/models/trip-segments.model';
import Person from '../../app/shared/models/person.model';
import BillingForm from '../shared/models/billing-form.model';
import DatePickerComponent from '@/app/shared/components/date-picker.component.vue';
import IndieInput from '@/app/shared/components/indie-input.vue';
import Itinerary from 'app/shared/models/itinerary.model';
import Payment from '../shared/models/payment.model';
import FlightsDetailsComponent from './components/flights-details.component.vue';
import PassengersComponent from './components/passengers.component.vue';
import PaymentComponent from './components/payment.component.vue';
import Tabs from './components/VueTabWithActiveLine.vue';
import TermsAndConditionsModal from './components/terms-and-conditions.vue';
import validators from './components/validators';
import {Country} from '../shared/models/country.model';
import {State} from '../shared/models/state.model';
import {BookingService} from '../services/booking.service';
import {IndieLogin} from '../services/indie-login';
import {TrackingCookie} from '../services/tracking-cookie';
import {GADissect} from '../services/gadissect';
import {CrmLogService} from "../services/crm-log.service";
import {BAGGAGE_FEE_PER_FLIGHT, AFFILIATE_COOKIE_NAME} from "../shared/common/constants";
import {CreditService} from "@/app/services/credit.service";
import {Inject} from "inversify-props";

const moment = require('moment');

const TABS = [{
    title: 'Passengers',
    value: 'tab-passengers',
}, {
    title: 'Flight details',
    value: 'tab-flights',
}, {
    title: 'Payment',
    value: 'tab-payment',
}];

@Component<Booking>({
    components: {
        Footer,
        DatePickerComponent,
        IndieInput,
        FlightsDetailsComponent,
        PassengersComponent,
        PaymentComponent,
        Tabs,
        TermsAndConditionsModal
    },

})

export default class Booking extends Vue {
    @Inject() private readonly creditService: CreditService;

    public store = store;
    public selectedSegments: Array<TripSegments>;
    public totalStops: number = 0;
    public totalCost: number | string = 1;
    public persons: Array<Person> = [];
    public cityList: Array<Itinerary> = [];
    public countryList: Array<Country> = [];
    public stateList: Array<State> = [];
    public searchInProcess = false;
    public billingForm: BillingForm;
    public isValidForm = true;
    public cardYearsList: Array<number>;
    public flightDetails = false;
    public currency: any =   {
        code: this.store.state.currency.code,
        sign: this.store.state.currency.sign,
        rate: this.store.state.currency.rate
    };
    public openedTabs = [{opened: true}, {opened: false}, {opened: false}];
    public paymentModel: Payment;
    public purchaseCheck = false;

    private bookingService = new BookingService;
    private itineraryId = 0;
    private resultId = 0;

    private indieLogin: IndieLogin;

    public tabs = TABS;
    public currentTab = 'tab-passengers';

    public isLoading: boolean = false;

    constructor() {
        super();

        this.itineraryId = this.store.state.itineraryId;
        this.resultId = this.store.state.resultId;

        this.indieLogin = new IndieLogin();

        this.cardYearsList = [];

        this.paymentModel = new Payment();

        if (store.state.selectedSegments && store.state.selectedSegments.length > 0) {
            this.selectedSegments = store.state.selectedSegments;

            for (let i = 0; i < this.selectedSegments.length; i++) {
                for (let j = 0; j < this.selectedSegments[i].stops.length; j++) {
                    this.totalStops++;
                }
            }

            validators().phoneValidator();
            this.totalCost = (+store.state.totalCost * this.currency.rate).toFixed();

            let travelers: any = store.state.search.travelers;
            for (let type in travelers) {
                for (let i = 0; i < travelers[type]; i++) {
                    this.persons.push(new Person(type));
                }
            }

            this.billingForm = new BillingForm();
        }

        this.$nextTick(() => {
            this.cardYears();
        })
    }

    public getTabIndexByName(tabName: string): number|null{
        for(let idx in this.tabs){
            if(tabName == this.tabs[idx].value){
                return parseInt(idx);
            }
        }
        return null;
    }
    public handleClick(newTab: any) {
      let tabIndex = this.getTabIndexByName(newTab);
      if(tabIndex == null){
          tabIndex = 0;
      }
      for(let i = tabIndex + 1; i < this.openedTabs.length; i++){
        if(this.openedTabs[i]){
          this.openedTabs[i].opened = false;
        }
      }
      this.currentTab = newTab;
    }

    public countCost(index: number) {
        const totalBaggageFee = this.selectedSegments.length * BAGGAGE_FEE_PER_FLIGHT * this.currency.rate;
        this.persons[index].preferences.include_baggage
            ? (this.totalCost = (+this.totalCost - totalBaggageFee).toFixed())
            : (this.totalCost = (+this.totalCost + totalBaggageFee).toFixed());
    }

    public checkFlightDetails() {
        if (this.flightDetails) {
            for (let i = 1; i < this.openedTabs.length; i++) {
                this.openedTabs[i].opened = false;
            }
        }

        this.flightDetails = !this.flightDetails;
    }

    public checkPurchase() {
        this.purchaseCheck = !this.purchaseCheck;
    }

    public cardNumberValidate(maxLength: number) {
        if (this.paymentModel.cc_number.length > maxLength) this.paymentModel.cc_number = this.paymentModel.cc_number.slice(0, maxLength);
    }

    public cvvValidate(maxLength: number) {
        if (this.paymentModel.card_cvv2.length > maxLength) {
            this.paymentModel.card_cvv2 = this.paymentModel.card_cvv2.slice(0, maxLength);
        }
    }

    public onCityChange(cityItem: any, type: string) {
        switch (type) {
            case 'city':
                this.billingForm.city = cityItem.value;
                break;
            case 'state':
                this.billingForm.state = cityItem.value;
                break;
            case 'country':
                this.billingForm.country = cityItem.value;
                break;
        }

    }

    public changeBilling(index: number) {
        if (!this.persons[index].isBilling) {
            this.persons[index].isBilling = !this.persons[index].isBilling;
            this.billingForm.first_name = this.persons[index].name;
            this.billingForm.last_name = this.persons[index].surname;
            for (let i = 0; i < this.persons.length; i++) {
                if (i !== index) {
                    this.persons[i].isBilling = false;
                }
            }
        } else {
            this.persons[index].isBilling = false;
        }
    }

    public selectDate(date: string, passengerId: number) {
        this.persons[passengerId].birthDate = date;
    }

    public onChangeNameSurname(id: number) {
        if (this.persons[id].isBilling) {
            this.billingForm.last_name = this.persons[id].surname;
            this.billingForm.first_name = this.persons[id].name;
        }
    }

    public nextStep(index: number, tab: string) {
        this.openedTabs[index].opened = true;
        this.currentTab = tab;
        window.scrollTo(0,0);
    }

    private cardYears() {
        this.cardYearsList = [];
        let nowYear = moment(new Date(), 'DD/MM/YYYY').format('YYYY');
        for (let i = 0; i < 10; i++) {

            this.cardYearsList.push(+nowYear + i);
        }

    }

    public submitBooking() {
        console.log("sub book");
        let travelers: any = {a: [], c: [], i: []};
        for (let person of this.persons) {
            travelers[person.type.toLowerCase()].push({
                first_name: person.name,
                last_name: person.surname,
                gender: person.gender,
                birthday:  moment(person.birthDate, 'DD-MMM-YYYY').format('MM/DD/YYYY'),
                preferences: person.preferences
            });
        }

        const ga_cookie = new GADissect().cookieProperties();

        return this.bookingService
            .book({
                itinerary_id: this.itineraryId,
                result_id: this.resultId,
                travelers,
                payment: {
                    pay_type: this.paymentModel.pay_type,
                    cc_type: this.paymentModel.cc_type,
                    cc_number: this.paymentModel.cc_number,
                    cc_ccv2: this.paymentModel.card_cvv2,
                    cc_expire_month: this.paymentModel.expire_month,
                    cc_expire_year: this.paymentModel.expire_year
                },
                billing: this.billingForm,
                contact: {
                    first_name: this.indieLogin.getFirstName(),
                    last_name: this.indieLogin.getLastName(),
                    email: this.indieLogin.getEmail(),
                    phone: ''
                },
                luggage_fee: false,
                tracking: {
                    affid: new TrackingCookie(AFFILIATE_COOKIE_NAME).get(),
                    dst: new TrackingCookie('bna_indie_dst').get(),
                    ref: new TrackingCookie('bna_indie_ref').get(),
                    pp: new TrackingCookie('bna_indie_pp').get(),
                    a: new TrackingCookie('bna_indie_a').get(),
                    o: new TrackingCookie('bna_indie_o').get(),
                    jid: new TrackingCookie('a_journey').get(),
                    ga: {
                        medium: ga_cookie.medium,
                        source: ga_cookie.source,
                        content: ga_cookie.content,
                        campaign: ga_cookie.campaign,
                        term: ga_cookie.term,
                        ga_clid: ga_cookie.ga_clid,
                        utmzlp: ga_cookie.utmzlp
                    }
                },
                credit: {
                    used_airline_credit: this.creditService.getUsedAirlineCredit(this.$store)
                }
            })
            .then(res => {
                this.$router.push('../../thank-you');
            });

    }

    created() {
        new CrmLogService().add(CrmLogService.LOG_REACHED_PURCHASE);
    }

    public navigateToFlightResults(){
        this.$router.replace(`/search-result/${this.itineraryId}/${this.resultId}`);
    }

    private get usingCredit(){
        return this.$store.state.creditData != undefined;
    }


}


